import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[luiSelectBoxContent]',
    standalone: false
})
export class SelectBoxContentDirective {
  @HostBinding('class') hostClass = 'lui-select-box-content';
}
